<script lang="ts">
    import { afterUpdate } from "svelte"
    import { fade } from "svelte/transition"

    import {
        generalInformation,
        events,
        free_weekend_appointments,
        ccTags,
    } from "../../store"

    import "../3rdparty/CoolClock/CoolClock"
    import "../3rdparty/CoolClock/skins"

    import Event from "../page/Event.svelte"
    import Appointment from "../page/Appointment.svelte"
    import VisitorCounter from "../page/VisitorCounter.svelte"

    let today = (() => {
        return new Date().toLocaleDateString("de-DE", {
            weekday: "short",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
    })()

    $: lastPageUpdate = new Date(
        $generalInformation?.lastPageUpdate
    ).toLocaleDateString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        // hour: "numeric",
        // minute: "numeric",
        // second: "numeric",
    })

    afterUpdate(() => {
        // @ts-ignore
        CoolClock.findAndCreateClocks()
    })
</script>

<div class="sidebar">
    <div class="layout layout-vertical layout-stretch layout-gap-xl">
        <div class="layout layout-vertical align-items-center layout-gap-md">
            <div class="today">{today}</div>
            <canvas
                class="CoolClock:swissRail"
                width="170"
                height="170"
                style="width: 170px; height: 170px;"></canvas>
        </div>

        {#if $generalInformation?.lastPageUpdate}
            <div class="lastPageUpdate">
                <div>letzte Aktualisierung</div>
                <div class="lastPageUpdate-date">
                    {lastPageUpdate}
                </div>
            </div>
        {/if}

        <div>
            <a
                href="https://www.mdr.de/nachrichten/thueringen/wetter/index.html#Gotha"
                target="_blank"
                class="layout justify-content-center"
            >
                <img src="assets/page/mdr-logo.png" alt="MDR Radio Thüringen" />
            </a>
            <div class="mt-md">
                Svend Walter ist offizieller Wettermelder beim MDR Radio
                Thüringen und des öfteren in der Vormittagssendung bei Sina
                Waage oder bei Matthias Haase live zu hören
            </div>
        </div>

        <img
            src="assets/page/Svend-Walter-002.jpg"
            alt="Svend Walter"
            class="rounded"
        />

        <div>
            <h3>Buchungsanfragen</h3>
            <div class="mt-md">
                Ab sofort nehme ich Ihre Terminreservierungen für 2025 und 2026
                gerne entgegen und freue mich auf Ihren Anruf oder Ihre Mail!
            </div>
            <div
                class="mt-md layout layout-gap-sm align-items-center contact-info"
            >
                <img src="assets/page/icon-phone-1.png" alt="Telefon" />
                <span>{$generalInformation?.tel}</span>
            </div>
            <div
                class="mt-md layout layout-gap-sm align-items-center contact-info"
            >
                <img src="assets/page/icon-phone-1-2.png" alt="Mobil" />
                <span>{$generalInformation?.mobile}</span>
            </div>
            <div
                class="mt-md layout layout-gap-sm align-items-center contact-info"
            >
                <img src="assets/page/icon-phone-1-3.png" alt="E-Mail" />
                <span>{$generalInformation?.email}</span>
            </div>
        </div>

        <div class="layout layout-vertical layout-gap-md">
            <h3>Freie Termine</h3>
            {#each $free_weekend_appointments || [] as appointment}
                <Appointment appointment="{appointment}" />
            {/each}
            <a href="/freie-termine">&raquo; zu den Terminen</a>
        </div>

        <img
            src="assets/page/svend-walter.png"
            alt="Svend Walter"
            class="rounded filled"
        />

        {#if $ccTags.includes("visitorCounter")}
            <div class="visitor-counter" transition:fade>
                <VisitorCounter />
            </div>
        {/if}

        <img
            src="assets/page/logo-alt.jpg"
            alt="Svend Walter"
            class="rounded filled"
        />
        <div class="layout layout-vertical layout-gap-md">
            <h3>Nicht vergessen</h3>
            {#each $events || [] as event}
                {#if event.position === "sidebar"}
                    <Event event="{event}" />
                {/if}
            {/each}
            <a href="/events" class="layout align-items-center layout-gap-sm">
                <img src="/assets/page/arrow-right-3.png" alt="Pfeil" />
                <span>weitere Veranstaltungen</span>
            </a>
        </div>
    </div>
</div>
